"use client";

import { SideMenuContent } from "@layout/SideMenu/SideMenuContent";
import { Box } from "@mui/material";
import {
  SIDE_MENU,
  SIDE_MENU_Z_INDEX,
} from "@shared/constants/SideMenuConstants";
import { useSideMenu } from "@shared/contexts/SideMenuContext";
import { useEffect } from "react";

export const SideMenu = () => {
  const { isOpenSideMenu, isMobile, setOpenSideMenu } = useSideMenu();

  useEffect(() => setOpenSideMenu(!isMobile), [isMobile, setOpenSideMenu]);

  return (
    <Box
      sx={(theme) => ({
        width: isOpenSideMenu ? SIDE_MENU.desktopWidth : "75px",
        transition: "width 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
        height: "100vh",
        position: "relative",
        zIndex: SIDE_MENU_Z_INDEX.desktop,
        backgroundColor: theme.palette.background.default,
      })}
    >
      <SideMenuContent />
    </Box>
  );
};
